interface BankInfoTagsCellDelegate
{
    tagsCellDidToggleTag(cell:BankInfoTagsCell, entry:BankEntry, tag:string, on:boolean): void;
}

// The movement's tags in the manager's tag view, like the product's: the ledger account tags of
// the tags configuration, plus any tag the movement already has, the movement's ones selected
class BankInfoTagsCell extends UITableViewCell
{
    delegate:BankInfoTagsCellDelegate = null;

    private tagView:TagView = null;
    private emptyLabel:MUILabel = null;

    private _entry:BankEntry = null;
    private names:string[] = [];

    awakeFromHTML(){
        this.tagView = MUIOutlet(this, "tags-view", "TagView");
        this.tagView.delegate = this;
        this.emptyLabel = MUIOutlet(this, "empty-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    setEntry(entry:BankEntry, availableTags:string[]){
        this._entry = entry;

        let current = BankMovementState.tagsOf(entry);
        this.names = availableTags.slice();
        for (let tag of current) {
            if (this.names.indexOf(tag) < 0) this.names.push(tag);
        }

        this.tagView.removeAll();
        for (let index = 0; index < this.names.length; index++){
            this.tagView.addTag(this.names[index]);
            if (current.indexOf(this.names[index]) > -1) this.tagView.selectTagAtIndex(index);
        }

        this.emptyLabel.hidden = this.names.length > 0;
    }

    didSelectTagAtIndex(index:number, name:string){
        if (this.delegate == null || this._entry == null) return;
        let on = BankMovementState.tagsOf(this._entry).indexOf(name) < 0;
        this.delegate.tagsCellDidToggleTag(this, this._entry, name, on);
    }
}
